import { Injectable } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { UserProfileActions } from './';

@Injectable({
  providedIn: 'root'
})
export class UserProfileResponse {
  constructor(private actions$: Actions) {}

  public userProfileHasReturnLink$ = this.actions$.pipe(
    ofType(UserProfileActions.userProfileHasReturnLink)
  );

  public userCompletesAnySurvey$ = this.actions$.pipe(
    ofType(UserProfileActions.userCompletesAnySurvey)
  );

  public isSkillsSurveyComplete$ = this.actions$.pipe(
    ofType(UserProfileActions.userSkillsSurveySavedSuccess)
  );
}
